import React from "react";
import { BarGraph } from "../../../components/ui/Graph";
import PropTypes from "prop-types";
import GraphDashboardRCS from "../utils/GraphDashboardRCS";
import { useGraphByHourRCS } from "../hooks/useGraphByHourRCS";
const GraphRCSDashboard = () => {
  const { data, isPending: loading, isFetching } = useGraphByHourRCS();

  const { labelsX, sendDataAxisY, responseDataAxisY } = React.useMemo(() => {
    const graph = new GraphDashboardRCS(data);
    const labelsX = graph.getLabelsAxisX();
    const sendDataAxisY = graph.getAxisYSendData();
    const responseDataAxisY = graph.getAxisYResponseData();

    const sendMap = {};
    const responseMap = {};

    labelsX.forEach((label, index) => {
      sendMap[label] = sendDataAxisY[index] || 0;
      responseMap[label] = responseDataAxisY[index] || 0;
    });

    const labelsComplete = [];
    const sendComplete = [];
    const responseComplete = [];

    const hourData = new Date();
    const maxX = hourData.getHours();

    for (let i = 0; i <= maxX; i++) {
      labelsComplete.push(i.toString().padStart(2, "0") + ":00");
      sendComplete.push(sendMap[labelsComplete[i]] || 0);
      responseComplete.push(responseMap[labelsComplete[i]] || 0);
    }

    return {
      labelsX: labelsComplete,
      sendDataAxisY: sendComplete,
      responseDataAxisY: responseComplete,
    };
  }, [data]);

  const max = Math.max(...sendDataAxisY);

  const dataGraph = {
    labels: labelsX,
    datasets: [
      {
        type: "line",
        label: "Enviados",
        borderColor: "rgb(239, 68, 68)",
        backgroundColor: "rgb(239, 68, 68)",
        yAxisID: "y1",
        data: sendDataAxisY,
        fill: false,
        tension: 0.2,
        pointStyle: "circle",
        pointRadius: 0,
      },
      {
        type: "bar",
        label: "Entregados",
        borderColor: "rgb(16, 163, 127)",
        backgroundColor: "rgb(16, 163, 127)",
        yAxisID: "y",
        data: responseDataAxisY,
        fill: false,
        tension: 0.2,
        pointStyle: "circle",
        pointRadius: 0,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    interaction: {
      mode: "index",
      intersect: false,
    },

    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#6b7280",
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        backgroundColor: "#ffffff",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        borderRadius: 8,
        titleColor: "#000000",
        bodyColor: "#000000",
        padding: 10,
        displayColors: false,
      },

      title: {
        display: false,
      },
    },

    scales: {
      x: {
        ticks: {
          color: "#6b7280",
          font: { size: 12 },
        },

        display: true,
        grid: {
          lineWidth: 0.5,
        },
      },
      y: {
        min: 0,
        max: max + 1,
        type: "linear",
        display: true,
        position: "right",
      },

      y1: {
        min: 0,
        max: max + 1,
        type: "linear",
        position: "left",
        ticks: {
          color: "#6b7280",
          font: { size: 12 },
        },
        display: true,
        grid: {
          lineWidth: 0.5,
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
    <BarGraph
      options={options}
      data={dataGraph}
      loading={loading || isFetching}
      exportData={data}
    />
  );
};

GraphRCSDashboard.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
};

export default GraphRCSDashboard;
